module.exports = __webpack_public_path__ + "static/media/agricultural8.ee4301ab.jpg";